// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__tL55b","button":"styles_button__bfCge"};